var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInBankruptcy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34766 5.29199H9.68018C11.1987 5.29199 12.2998 5.50928 12.9834 5.94385C13.6719 6.37354 14.0161 7.05957 14.0161 8.00195C14.0161 8.6416 13.8647 9.1665 13.562 9.57666C13.2642 9.98682 12.8662 10.2334 12.3682 10.3164V10.3896C13.0469 10.541 13.5352 10.8242 13.833 11.2393C14.1357 11.6543 14.2871 12.2061 14.2871 12.8945C14.2871 13.8711 13.9331 14.6328 13.2251 15.1797C12.522 15.7266 11.5649 16 10.354 16H6.34766V5.29199ZM8.61816 9.53271H9.93652C10.5518 9.53271 10.9961 9.4375 11.2695 9.24707C11.5479 9.05664 11.687 8.7417 11.687 8.30225C11.687 7.89209 11.5356 7.59912 11.2329 7.42334C10.9351 7.24268 10.4614 7.15234 9.81201 7.15234H8.61816V9.53271ZM8.61816 11.3345V14.125H10.0977C10.7227 14.125 11.1841 14.0054 11.4819 13.7661C11.7798 13.5269 11.9287 13.1606 11.9287 12.6675C11.9287 11.7788 11.2939 11.3345 10.0244 11.3345H8.61816Z",
    fill: "#C40F11"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInBankruptcy);
export default __webpack_public_path__ + "static/media/in-bankruptcy.d18e17222867939a3f2b393dfd9f0240.svg";
export { ForwardRef as ReactComponent };